module.exports = __webpack_public_path__ + "static/media/game-display-1@768.8b47fba0.png";